export const COUNTRY_LANGUAGE_MAP = {
  "Benin": "fr",
  // "Burkina Faso": "fr",
  "Cabo Verde": "pt",
  "Côte d’Ivoire": "fr",
  "The Gambia": "en",
  "Ghana": "en",
  "Guinea": "fr",
  "Guinea-Bissau": "pt",
  "Liberia": "en",
  // "Mali": "fr",
  // "Niger": "fr",
  "Nigeria": "en",
  "Senegal": "fr",
  "Sierra Leone": "en",
  "Togo": "fr",
  "Cameroon": "fr", // bilingual country (fr/en), French used as default
};

export const SUPPORTED_COUNTRIES = [
  "Benin",
  // "Burkina Faso",
  "Cabo Verde",
  "Côte d’Ivoire",
  "The Gambia",
  "Ghana",
  "Guinea",
  "Guinea-Bissau",
  "Liberia",
  // "Mali",
  // "Niger",
  "Nigeria",
  "Senegal",
  "Sierra Leone",
  "Togo",
  "Cameroon",
];

export const SUPPORTED_STATES = {
  // 🇳🇬 Nigeria (36 states + FCT)
  "Nigeria": [
    "Abia","Adamawa","Akwa Ibom","Anambra","Bauchi","Bayelsa","Benue","Borno",
    "Cross River","Delta","Ebonyi","Edo","Ekiti","Enugu","Gombe","Imo","Jigawa",
    "Kaduna","Kano","Katsina","Kebbi","Kogi","Kwara","Lagos","Nasarawa","Niger",
    "Ogun","Ondo","Osun","Oyo","Plateau","Rivers","Sokoto","Taraba","Yobe","Zamfara",
    "FCT"
  ],

  // 🇬🇭 Ghana (16 regions)
  "Ghana": [
    "Greater Accra","Ashanti","Central","Eastern","Western","Western North",
    "Volta","Oti","Northern","Savannah","North East",
    "Upper East","Upper West","Bono","Bono East","Ahafo"
  ],

  // 🇧🇯 Benin (12 departments)
  "Benin": [
    "Alibori","Atakora","Atlantique","Borgou","Collines","Couffo",
    "Donga","Littoral","Mono","Ouémé","Plateau","Zou"
  ],

  // 🇧🇫 Burkina Faso (13 regions)
  "Burkina Faso": [
    "Boucle du Mouhoun","Cascades","Centre","Centre-Est","Centre-Nord",
    "Centre-Ouest","Centre-Sud","Est","Hauts-Bassins",
    "Nord","Plateau-Central","Sahel","Sud-Ouest"
  ],

  // 🇨🇻 Cabo Verde (islands)
  "Cabo Verde": [
    "Santiago","São Vicente","Santo Antão","Fogo","Sal","Boa Vista",
    "Maio","Brava","São Nicolau","Santa Luzia"
  ],

  // 🇨🇮 Côte d’Ivoire (districts)
  "Côte d’Ivoire": [
    "Abidjan","Yamoussoukro","Bas-Sassandra","Comoé",
    "Denguélé","Gôh-Djiboua","Lacs","Lagunes",
    "Montagnes","Sassandra-Marahoué","Savanes","Vallée du Bandama","Woroba","Zanzan"
  ],

  // 🇬🇲 The Gambia
  "The Gambia": [
    "Banjul","Kanifing","West Coast","North Bank","Lower River","Central River","Upper River"
  ],

  // 🇬🇳 Guinea
  "Guinea": [
    "Conakry","Boké","Kindia","Mamou","Labé","Faranah","Kankan","Nzérékoré"
  ],

  // 🇬🇼 Guinea-Bissau
  "Guinea-Bissau": [
    "Bissau","Biombo","Bolama","Cacheu","Gabú","Oio","Quinara","Tombali"
  ],

  // 🇱🇷 Liberia
  "Liberia": [
    "Bomi","Bong","Gbarpolu","Grand Bassa","Grand Cape Mount","Grand Gedeh",
    "Grand Kru","Lofa","Margibi","Maryland","Montserrado",
    "Nimba","River Cess","River Gee","Sinoe"
  ],

  // 🇲🇱 Mali
  "Mali": [
    "Bamako","Kayes","Koulikoro","Sikasso","Ségou","Mopti","Tombouctou","Gao","Kidal","Ménaka","Taoudénit"
  ],

  // 🇳🇪 Niger
  "Niger": [
    "Agadez","Diffa","Dosso","Maradi","Niamey","Tahoua","Tillabéri","Zinder"
  ],

  // 🇸🇳 Senegal
  "Senegal": [
    "Dakar","Diourbel","Fatick","Kaffrine","Kaolack","Kédougou","Kolda",
    "Louga","Matam","Saint-Louis","Sédhiou","Tambacounda","Thiès","Ziguinchor"
  ],

  // 🇸🇱 Sierra Leone
  "Sierra Leone": [
    "Western Area","Northern Province","North West Province","Eastern Province","Southern Province"
  ],

  // 🇹🇬 Togo
  "Togo": [
    "Maritime","Plateaux","Centrale","Kara","Savanes"
  ],

  // 🇨🇲 Cameroon (10 regions)
  "Cameroon": [
    "Adamawa","Centre","East","Far North","Littoral",
    "North","North West","South","South West","West"
  ]
};

export const SUPPORTED_CITIES = {

  /* =========================
     🇳🇬 NIGERIA
  ========================== */
  "Abia": ["Umuahia","Aba","Ohafia"],
  "Adamawa": ["Yola","Mubi","Numan","Ganye"],
  "Akwa Ibom": ["Uyo","Eket","Ikot Ekpene","Oron"],
  "Anambra": ["Awka","Onitsha","Nnewi","Ekwulobia"],
  "Bauchi": ["Bauchi","Azare","Misau"],
  "Bayelsa": ["Yenagoa","Ogbia","Sagbama"],
  "Benue": ["Makurdi","Gboko","Otukpo"],
  "Borno": ["Maiduguri","Bama","Dikwa"],
  "Cross River": ["Calabar","Ikom","Ogoja"],
  "Delta": ["Asaba","Warri","Sapele","Ughelli"],
  "Ebonyi": ["Abakaliki","Afikpo","Onueke"],
  "Edo": ["Benin City","Auchi","Ekpoma"],
  "Ekiti": ["Ado-Ekiti","Ikere","Oye"],
  "Enugu": ["Enugu","Nsukka","Awgu"],
  "Gombe": ["Gombe","Kaltungo","Billiri"],
  "Imo": ["Owerri","Orlu","Okigwe"],
  "Jigawa": ["Dutse","Hadejia","Gumel"],
  "Kaduna": ["Kaduna","Zaria","Kafanchan","Birnin Gwari"],
  "Kano": ["Kano","Wudil","Gaya","Rano"],
  "Katsina": ["Katsina","Daura","Funtua"],
  "Kebbi": ["Birnin Kebbi","Argungu","Yauri"],
  "Kogi": ["Lokoja","Okene","Idah","Kabba"],
  "Kwara": ["Ilorin","Offa","Omu-Aran"],
  "Lagos": ["Ikeja","Lekki","Yaba","Surulere","Badagry","Epe"],
  "Nasarawa": ["Lafia","Keffi","Akwanga"],
  "Niger": ["Minna","Bida","Kontagora","Suleja"],
  "Ogun": ["Abeokuta","Ota","Ijebu-Ode","Sagamu"],
  "Ondo": ["Akure","Ondo","Owo","Ikare"],
  "Osun": ["Osogbo","Ile-Ife","Ilesa","Ede"],
  "Oyo": ["Ibadan","Ogbomosho","Oyo","Iseyin"],
  "Plateau": ["Jos","Bukuru","Shendam"],
  "Rivers": ["Port Harcourt","Bonny","Degema","Ahoada"],
  "Sokoto": ["Sokoto","Wamako","Gwadabawa"],
  "Taraba": ["Jalingo","Wukari","Takum"],
  "Yobe": ["Damaturu","Potiskum","Gashua"],
  "Zamfara": ["Gusau","Kaura Namoda","Talata Mafara"],
  "FCT": ["Abuja","Garki","Wuse","Maitama","Kubwa"],

  /* =========================
     🇬🇭 GHANA
  ========================== */
  "Greater Accra": ["Accra","Tema","Madina","Osu","Nungua"],
  "Ashanti": ["Kumasi","Obuasi","Ejisu","Mampong"],
  "Central": ["Cape Coast","Winneba","Elmina"],
  "Eastern": ["Koforidua","Nkawkaw","Akim Oda"],
  "Western": ["Takoradi","Sekondi","Tarkwa"],
  "Western North": ["Sefwi Wiawso","Bibiani","Enchi"],
  "Volta": ["Ho","Keta","Hohoe"],
  "Oti": ["Dambai","Kadjebi","Nkwanta"],
  "Northern": ["Tamale","Yendi","Savelugu"],
  "Savannah": ["Damongo","Bole","Sawla"],
  "North East": ["Nalerigu","Walewale","Gambaga"],
  "Upper East": ["Bolgatanga","Navrongo","Bawku"],
  "Upper West": ["Wa","Lawra","Jirapa"],
  "Bono": ["Sunyani","Berekum","Dormaa Ahenkro"],
  "Bono East": ["Techiman","Kintampo","Nkoranza"],
  "Ahafo": ["Goaso","Kenyasi","Bechem"],

  /* =========================
     🇧🇯 BENIN
  ========================== */
  "Alibori": ["Kandi","Malanville","Banikoara"],
  "Atakora": ["Natitingou","Tanguiéta","Boukoumbé"],
  "Atlantique": ["Abomey-Calavi","Allada","Ouidah"],
  "Borgou": ["Parakou","Nikki","Tchaourou"],
  "Collines": ["Dassa-Zoumè","Savalou","Bantè"],
  "Couffo": ["Aplahoué","Dogbo","Djakotomey"],
  "Donga": ["Djougou","Bassila","Copargo"],
  "Littoral": ["Cotonou"],
  "Mono": ["Lokossa","Athiémé","Bopa"],
  "Ouémé": ["Porto-Novo","Adjarra","Dangbo"],
  "Pla-teau": ["Pobè","Kétou","Ifangni"],
  "Zou": ["Abomey","Bohicon","Zagnanado"],

  /* =========================
     🇨🇲 CAMEROON
  ========================== */
  "Ada-mawa": ["Ngaoundéré","Meiganga","Tibati"],
  "Centre": ["Yaoundé","Mbalmayo","Obala","Mfou"],
  "East": ["Bertoua","Batouri","Abong-Mbang"],
  "Far North": ["Maroua","Kousséri","Mokolo","Yagoua"],
  "Li-ttoral": ["Douala","Nkongsamba","Edéa","Loum"],
  "North": ["Garoua","Guider","Poli"],
  "North West": ["Bamenda","Kumbo","Ndop","Wum"],
  "South": ["Ebolowa","Kribi","Sangmélima"],
  "South West": ["Buea","Limbe","Kumba","Tiko"],
  "West": ["Bafoussam","Dschang","Foumban","Mbouda"],

  /* =========================
     🇸🇳 SENEGAL
  ========================== */
  "Dakar": ["Dakar","Pikine","Guédiawaye","Rufisque"],
  "Diourbel": ["Diourbel","Touba","Mbacké"],
  "Fatick": ["Fatick","Foundiougne","Gossas"],
  "Kaolack": ["Kaolack","Nioro","Guinguinéo"],
  "Kédougou": ["Kédougou","Salemata","Saraya"],
  "Kolda": ["Kolda","Vélingara","Médina Yoro Foulah"],
  "Louga": ["Louga","Kébémer","Linguère"],
  "Matam": ["Matam","Kanel","Ranérou"],
  "Saint-Louis": ["Saint-Louis","Richard Toll","Dagana"],
  "Thiès": ["Thiès","Mbour","Tivaouane"],
  "Ziguinchor": ["Ziguinchor","Oussouye","Bignona"],

  /* =========================
     🇹🇬 TOGO
  ========================== */
  "Maritime": ["Lomé","Aného","Tsévié"],
  "Plateaux": ["Atakpamé","Kpalimé","Badou"],
  "Centrale": ["Sokodé","Tchamba","Blitta"],
  "Kara": ["Kara","Bafilo","Niamtougou"],
  "Savanes": ["Dapaong","Mango","Tandjouaré"]
};